import { Classes } from "@blueprintjs/core";
import React from "react";

export const DialogBody = (p: { children: React.ReactNode | JSX.Element }) => (
  <div className={Classes.DIALOG_BODY} children={p.children} />
);

export const DialogFooter = (p: { children: React.ReactNode | JSX.Element }) => (
  <div className={Classes.DIALOG_FOOTER} children={p.children} />
);
